"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));

var _default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M21.814 13.916c0-1.622-.982-3.069-2.451-3.608V9.66c0-4.23-3.293-7.66-7.354-7.66S4.655 5.43 4.655 9.66v.648c-1.471.54-2.455 1.988-2.455 3.613s.984 3.072 2.455 3.612c.375.138.793.078 1.118-.163.325-.24.517-.63.516-1.046V9.66c0-2.128 1.09-4.095 2.86-5.16a5.522 5.522 0 015.72 0c1.77 1.065 2.86 3.032 2.86 5.16v6.664c.003.358.151.698.408.937v.483c0 1.255-1.055 1.702-2.043 1.702h-1.453c-.37-.667-1.123-.992-1.838-.793-.714.2-1.211.874-1.211 1.645s.497 1.444 1.211 1.644c.715.2 1.469-.126 1.838-.793h1.453c2.165 0 3.677-1.4 3.677-3.405v-.407c1.248-.645 2.04-1.97 2.043-3.42z"
})), "0 0 24 24", "CustomerSupport");

exports.default = _default;